import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from '@repo/common';

const AUTO_CLOSE_DELAY = 10000;

const SuccessNotificationToast = ({
  isOpen,
  onClose,
  type = 'bag', // 'bag' | 'waitlist'
  onViewClick,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return undefined;

    const timer = setTimeout(() => {
      onClose && onClose();
    }, AUTO_CLOSE_DELAY);

    return () => clearTimeout(timer);
  }, [isOpen, onClose]);

  const handleClose = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    onClose && onClose();
  };

  const handleViewClick = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (onViewClick) {
      onViewClick();
    } else {
      // 기본 동작: 예약 페이지로 이동
      navigate('/community/kpathport/booking');
    }
    onClose && onClose();
  };

  if (!isOpen) return null;

  const title =
    type === 'bag'
      ? 'Added to your bag'
      : type === 'alreadyInBag'
        ? 'Already in your bag'
        : "You're on the waitlist";
  const buttonLabel =
    type === 'bag' || type === 'alreadyInBag' ? 'View bag' : 'View waitlist';

  return (
    <>
      {/* Desktop Toast - Bottom Center */}
      <div className='hidden tabletH:fixed tabletH:bottom-[24px] tabletH:left-1/2 tabletH:-translate-x-1/2 tabletH:z-[1000] tabletH:block'>
        <Toast
          visibleOn='desktop'
          type='success'
          state='white'
          hierarchy='mostImportant'
          title={title}
          message=''
          onClose={handleClose}
          buttonLabel={buttonLabel}
          onButtonClick={handleViewClick}
          direction='up'
          customWidth='auto'
        />
      </div>

      {/* Mobile Toast - Bottom Center */}
      <div className='tabletH:hidden fixed bottom-[24px] left-0 right-0 px-4 z-[9999999] flex justify-center'>
        <Toast
          visibleOn='mobile'
          type='success'
          state='white'
          hierarchy='mostImportant'
          title={title}
          message=''
          onClose={handleClose}
          useSmallIcon={true}
          hideActions={true}
          direction='up'
          customWidth='auto'
        />
      </div>
    </>
  );
};

export default SuccessNotificationToast;
